import { DEBUG_MODE } from './spdConfig';

export class FingerPrint {
  public static getBrowser() {
    const userAgent = navigator.userAgent;
    let browser = 'Unknown';

    // Detect Chrome
    if (/Chrome/.test(userAgent) && !/Chromium/.test(userAgent)) {
      browser = 'Google Chrome';
    }
    // Detect Chromium-based Edge
    else if (/Edg/.test(userAgent)) {
      browser = 'Microsoft Edge';
    }
    // Detect Firefox
    else if (/Firefox/.test(userAgent)) {
      browser = 'Mozilla Firefox';
    }
    // Detect Safari
    else if (/Safari/.test(userAgent)) {
      browser = 'Apple Safari';
    }
    // Detect Internet Explorer
    else if (/Trident/.test(userAgent)) {
      browser = 'Internet Explorer';
    }
    return browser;
  }

  public static getOS() {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    let os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  }

  public static getRawFingerPrint() {
    return navigator.userAgent + ';' + screen.width + ' x ' + screen.height;
  }

  public static getFingerPrint() {
    const fingerPrint = FingerPrint.getRawFingerPrint();
    const fingerPrint64 = btoa(fingerPrint);

    DEBUG_MODE && console.log('getFingerPrint', fingerPrint, fingerPrint64);

    return fingerPrint64;
  }
}
